import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('input').forEach(input => input.addEventListener('invalid', this.onInvalid));
  }

  get trigger() {
    return this.element.querySelector('input[type="checkbox"]');
  }

  onInvalid = (evt) => {
    if (this.trigger && !this.trigger.checked) {
      this.trigger.click();
    }
  }

  disconnect() {
    this.element.querySelectorAll('input').forEach(input => input.removeEventListener('invalid', this.onInvalid));
  }
}

